<div class="lds-ellipsis" [ngClass]="{ inverted: invertedColor }">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
